import { createSlice } from "@reduxjs/toolkit";
import {
  fetchYoutubeChannels,
  delinkChannel,
  handleSubmit,
} from "../services/operations/youtubeAPI";

const initialState = {
  addAccount: false,
  addAccountData: null,
  youtubeChannels: [],
  loading: false,
  error: null,
  selectedChannelId: null,
};

const youtubeSlice = createSlice({
  name: "youtube",
  initialState,
  reducers: {
    setSelectedChannelId: (state, action) => {
      state.selectedChannelId = action.payload;
    },
    clearYoutubeChannelData(state) {
      state.youtubeChannels = initialState.youtubeChannels;
      state.selectedChannelId = null;
      state.error = null;
      state.addAccount = null;
    },
    setYoutubeChannels: (state, action) => {
      state.youtubeChannels = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Reducers for fetchYoutubeChannels
    builder.addCase(fetchYoutubeChannels.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchYoutubeChannels.fulfilled, (state, action) => {
      state.youtubeChannels = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchYoutubeChannels.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });

    // Reducers for delinkChannels
    builder.addCase(delinkChannel.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(delinkChannel.fulfilled, (state, action) => {
      state.loading = false;
      const delinkedChannelId = action.payload.channel_id;
      state.youtubeChannels = state.youtubeChannels.filter(
        (channel) => channel.id !== delinkedChannelId
      );
    });
    builder.addCase(delinkChannel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Reducers for handleSubmit (editChannel)
    builder.addCase(handleSubmit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(handleSubmit.fulfilled, (state, action) => {
      state.loading = false;
      // Ensure the payload is an array of channels
      if (Array.isArray(action.payload)) {
        state.youtubeChannels = action.payload; // Set the new list of channels
      } else {
        console.error(
          "Expected an array of channels, but got:",
          action.payload
        );
      }
    });
    builder.addCase(handleSubmit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const {
  setSelectedChannelId,
  clearYoutubeChannelData,
  setYoutubeChannels,
} = youtubeSlice.actions;

export default youtubeSlice.reducer;
